import React, { useState } from "react";
import classes from "./styles/payment.module.css";
import { scheduleCalendlyEvent } from "../../services/CalendlyEvent";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

const plans = [
  { name: "Fit & Nourish (Monthly)", amount: 9999 },
  { name: "Fit & Nourish (Quarterly)", amount: 24000 },
  { name: "Nourish You (Monthly)", amount: 4999 },
  { name: "Nourish You (Quarterly)", amount: 9999 }
];

const slots = [
  { starttime: "6:00", endtime: "6:40", daytime: "AM" },
  { starttime: "7:00", endtime: "7:40", daytime: "AM" },
  { starttime: "8:00", endtime: "8:40", daytime: "AM" },
];

const days = [
  "Mon, Wed, Fri",
  "Tue, Thu, Sat",
];

const Payment = () => {
  const [name , setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(plans[0]);
  const [selectedDays, setSelectedDays] = useState(days[0]);
  const [slot, setSlot] = useState(slots[0]);


  const checkPaymentStatus = async (paymentId) => {
    const key_id = "rzp_live_jSnK0piAvQII8t"; 
    const key_secret = "7BH6ZPZINoGkWHCS11gHpt9w"; 
  
    const encoded = btoa(`${key_id}:${key_secret}`);
  
    try {
      const response = await fetch(`https://api.razorpay.com/v1/payments/${paymentId}`, {
        headers: {
          Authorization: `Basic ${encoded}`,
        },
      });
  
      const data = await response.json();
      console.log("Payment Status:", data.status);
  
      if (data.status === "captured" || data.status === "authorized") {
        // Payment successful – book Calendly here
        const calendlyResult = await scheduleCalendlyEvent(
          { name, email, contact },
          `${slot.starttime} - ${slot.endtime} ${slot.daytime}`
        );
        toast.success("Payment verified! Redirecting...");
        window.open(calendlyResult?.bookingUrl, '_blank');
      } else {
        toast.error("Payment not successful: " + data.status);
      }
    } catch (error) {
      toast.error("Error verifying payment.");
      console.error("Verification error:", error);
    }
  };
  
  const loadRazorpay = () => {
    if (!name || !email || !contact || !selectedDays) {
      toast.error("All fields are mandatory!");
      return;
    }

    if (name.length < 5) {
      toast.error("Name should be at least 5 characters long.");
      return;
    }

    if (contact.length < 10 || contact.length > 10) {
      toast.error("Contact Number is Invalid.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onerror = () => {
      toast.error("Razorpay SDK failed to load. Are you online?");
    };
    script.onload = async () => {
      const options = {
        // key: "rzp_test_Rni58DS3A0eNux",
        key: "rzp_live_jSnK0piAvQII8t",
        amount: selectedPlan.amount * 100, // = ₹999.00 (in paise)
        currency: "INR",
        name: "Get Fit With Susmita",
        description: `Hi my name is ${name}, my email is ${email}, my contact number is ${contact} and I have chosen ${selectedPlan.name} plan for ${slot.starttime}-${slot.endtime}${slot.daytime}  Slot for these days ${selectedDays}`,
        image: "https://ashy-smoke-04007be10.6.azurestaticapps.net/favicon.ico",
        prefill: {
          name: name,
          email: email,
          contact: contact,
        },
        theme: {
          color: "#0B4650",
        },
        handler: async function (response) {
          await checkPaymentStatus(response.razorpay_payment_id)
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    };
    document.body.appendChild(script);
};

document.title = "Checkout | Get Fit With Susmita"

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Checkout | Get Fit With Susmita</title>
      </Helmet>
      <div className={classes.innerCon}>
        <h2>Choose your plan</h2>
        <div>
          <label htmlFor="">Full Name</label>
          <input type="text" placeholder="Enter your name" value={name} onChange={(e) => {
            const value = e.target.value;
            if (/^[^0-9]*$/.test(value)) {
              setName(value);
            } else {
              toast.error("Numbers are not allowed in the name.");
            }
          }}/> 
          <label htmlFor="">Email</label>
          <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)}/>
          <label htmlFor="">Number</label> 
          <input type="number" placeholder="Enter your number" value={contact} onChange={(e) => setContact(e.target.value)}/> 
          <label htmlFor="">Plan</label>
          <select
        value={selectedPlan.name}
        onChange={(e) =>
          setSelectedPlan(plans.find((plan) => plan.name === e.target.value))
        }
      >
        {plans.map((plan, index) => (
          <option key={index} value={plan.name}>
            {plan.name} ₹{plan.amount}
          </option>
        ))}
      </select>
      <label htmlFor="">Time</label>
      <select
        value={`${slot.starttime} - ${slot.endtime} ${slot.daytime}`}
        onChange={(e) =>
          setSlot(
            slots.find(
              (s) =>
                `${s.starttime} - ${s.endtime} ${s.daytime}` === e.target.value
            )
          )
        }
      >
        {slots.map((s, index) => (
          <option key={index} value={`${s.starttime} - ${s.endtime} ${s.daytime}`}>
            {`${s.starttime} – ${s.endtime} ${s.daytime}`}
          </option>
        ))}
      </select>

      <label htmlFor="">Days</label>
      <select
        value={selectedDays}
        onChange={(e) => setSelectedDays(e.target.value)}
      >
        {days.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>

      <button onClick={loadRazorpay} className={`${classes.btn}`}>Checkout Now</button>
        </div>
      </div>     
    </div>
  );
};

export default Payment;
